import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "divider": "web_ui__Divider__divider",
  "vertical": "web_ui__Divider__vertical",
  "inverse": "web_ui__Divider__inverse",
  "active": "web_ui__Divider__active"
};

var DIVIDER_ORIENTATION_VALUES = ['horizontal', 'vertical'];
/* ---------- Back-compat shims (public API) ---------- */
var DIVIDER_ORIENTATION = {
  Horizontal: 'horizontal',
  Vertical: 'vertical'
};
var cssClasses = classNames.bind(styles);
var DividerBase = function DividerBase(_ref) {
  var _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    testId = _ref.testId,
    className = _ref.className;
  var dividerClass = cssClasses('divider', {
    vertical: orientation === 'vertical',
    inverse: inverse,
    active: active
  }, className);
  return /*#__PURE__*/jsx("div", {
    className: dividerClass,
    "data-testid": testId
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Divider = _Object$assign(DividerBase, {
  /**
   * @deprecated Use string literals instead: 'horizontal', 'vertical'
   */
  Orientation: DIVIDER_ORIENTATION
});

export { DIVIDER_ORIENTATION, DIVIDER_ORIENTATION_VALUES, Divider, Divider as default };
//# sourceMappingURL=Divider.js.map
